import './index.scss';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../../../../../../components/Header/Header';
import NoData from '../../../../../../../components/NoData/NoData';
import useInvestify from '../../../../../../../hooks/useInvestify';
import { InvestifyCategory } from '../../../../../../../types';
import InvestifyInvestmentList from '../InvestifyInvestmentList';
import { Loader } from '@piggytechng/component-library';

const index = () => {
  const params = useParams();
  const navigate = useNavigate();
  const activeTab = params.activeTab as InvestifyCategory;
  const id = params.id as string;

  const { InvestmentList, isLoadingInvestmentList } = useInvestify({ category: activeTab });

  const pageTitle = activeTab === 'ipo' ? 'IPO Investments' : `${activeTab} Investments`;

  const handleShowTransactionsDetails = (data: any) => {
    if (activeTab === 'ipo') {
      navigate(`/view-ipo-investment/${id}/${data.investId}`);
      return;
    }
    navigate(`/view-investment/${id}/${data.investId}/${activeTab}`);
  };

  return (
    <div className="view-all-investify">
      <Header name={pageTitle} backButton />
      <div className="content">
        <div className="customers-filter">
          <div className="input-field">
            <form action="" onSubmit={() => {}}>
              <input type="text" placeholder="Search by Transaction ID, date" />
            </form>
          </div>
          <div className="query-filter">
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          <div className="query-filter">
            <div></div>
            <div>Reset</div>
          </div>
        </div>

        {isLoadingInvestmentList ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            {InvestmentList && InvestmentList.length ? (
              <InvestifyInvestmentList items={InvestmentList} onItemClick={handleShowTransactionsDetails} />
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default index;
